import { render, staticRenderFns } from "./scholarships_data_tab.vue?vue&type=template&id=97678a44&scoped=true"
import script from "./scholarships_data_tab.vue?vue&type=script&lang=js"
export * from "./scholarships_data_tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97678a44",
  null
  
)

export default component.exports